import React from "react";
import CustomToolTip from './ToolTip';
import clsx from 'clsx';
import _ from 'lodash';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { makeStyles } from "@material-ui/core/styles";
import { Avatar } from "@material-ui/core";

const useStylesBootstrap = makeStyles(theme => ({
    cellTooltip: {
        padding: '5px 10px',
    },
    nameSection: {
        display: 'flex',
        alignItems: 'center'
    },
    headerContainer: {
        borderBottom: "1px solid #E6EDF5",
        display: "flex",
        flexDirection: "column",
        padding: "5px 10px"
    },
    avatar: {
        marginRight: 10,
        height: 30,
        width: 30,
        backgroundColor: "#0A54A2"
    },
    nameText: {
        display: "inline-block",
        overflow: "hidden"
    },
    nameTextBold: {
        fontSize: "16px",
        display: "inline-block",
        overflow: "hidden",
        fontWeight: "bold"
    },
    genieHeader: {
        fontSize: "12px",
        fontWeight: 700,
        color: '#878787',
        paddingRight: '5px'
    },
    genieData: {
        color: "black",
        fontSize: "12px",
    },
    tooltipBodyContainer: {
        padding: "5px 10px",
    },
}));

export default function TooltipDataviewEmployee(props) {
    const { ...classes } = useStylesBootstrap();

    let { listCol, data, kronosUrl, valueWithPhoto = true, indexName = 0 } = props;

    let colPhoto = _.find(listCol, ['key', 'EMP_COMMON_PHOTO_ID']);

    let tooltipEE =
        <React.Fragment>
            <div className={clsx(classes.cellTooltip)}>
                <div className={classes.headerContainer}>
                    {(!valueWithPhoto && kronosUrl) ?
                        <div className={classes.nameSection}>
                            {(typeof colPhoto === 'undefined' || data[colPhoto.alias] === '') ?
                                <Avatar className={classes.avatar}>{data[listCol[indexName].alias][0]}</Avatar>
                                :
                                <Avatar className={classes.avatar} src={kronosUrl + 'employee/photo?photoId=' + data[colPhoto.alias]}></Avatar>
                            }
                            <div className={classes.nameTextBold}>{data[listCol[indexName].alias]}</div>
                        </div>
                        : <span>{data[listCol[indexName].alias]}</span>}
                </div>
                <table className={classes.tooltipBodyContainer}>
                    <tbody>
                        {
                            listCol.map((col, index) => {
                                if (index > 0 && col.key !== 'EMP_COMMON_PHOTO_ID') {
                                    let value = typeof data[col.alias] === 'undefined' ? '' : data[col.alias];

                                    switch (value.toLowerCase()) {
                                        case 'true':
                                        case true:
                                            value = <FontAwesomeIcon style={{ color: 'green' }} icon={faCheck} />
                                            break;
                                        case 'false':
                                        case false:
                                            value = <FontAwesomeIcon style={{ color: 'red' }} icon={faTimes} />;
                                            break;
                                        case 'empty':
                                            value = '';
                                            break;
                                        default:
                                            break;
                                    }
                                    return (
                                        <tr>
                                            <td className={classes.genieHeader}>{col.label}</td>
                                            <td className={classes.genieData}>{value}</td>
                                        </tr>
                                    )
                                }
                                return <></>;
                            })
                        }
                    </tbody>
                </table>
            </div>
        </React.Fragment>

    return (
        <CustomToolTip
            style={{ width: '100%' }}
            titletext={tooltipEE}
            jsx={
                valueWithPhoto ?
                    <div className={classes.nameSection}>
                        {typeof colPhoto === 'undefined' ?
                            <Avatar className={classes.avatar}>{data[listCol[indexName].alias][0]}</Avatar>
                            :
                            <Avatar className={classes.avatar} src={kronosUrl + 'employee/photo?photoId=' + data[colPhoto.alias]}></Avatar>
                        }
                        <div className={classes.nameText}>{data[listCol[indexName].alias]}</div>
                    </div>
                    : <span>{data[listCol[indexName].alias]}</span>
            }
        />
    );
}